import { render, staticRenderFns } from "./activity-refuel-share-detail.vue?vue&type=template&id=081d17d6&"
import script from "./activity-refuel-share-detail.vue?vue&type=script&lang=js&"
export * from "./activity-refuel-share-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports